import React from 'react';
import { AdSlot as DfpAdSlot } from 'react-dfp';

export interface AdSlotTargetingArguments {
  lang: string;
  url: string;
  platform: AdPlatform;
  sect: string | string[];
  subsect?: string;
  isTest?: 'yes';
}

export type AdPlatform = 'web' | 'midi' | 'mobile';

export interface AdSlotProps {
  adUnit: string;
  targetingArguments: AdSlotTargetingArguments;
  size: [width: number, height: number];
}

const AdSlot: React.FC<AdSlotProps> = ({
  adUnit,
  targetingArguments,
  size,
}) => {
  return (
    <DfpAdSlot
      sizes={[size]}
      targetingArguments={targetingArguments}
      adUnit={adUnit}
    />
  );
};

export default AdSlot;
